<header>
    <nav #navbar class='main-panel navbar navbar-expand-sm navbar-toggleable-sm navbar-dark bg-dark border-bottom box-shadow'>
        <div class="container-fluid">
            <!-- <a class="navbar-brand" [routerLink]='["/"]'></a> -->
            <img [src]="EurofinsIconPath" (click)="navigateToHome()">
            <span class="mx-3" style="color: white; font-size: 32px;"> {{AppName}}</span>
            <!-- <button #toggleButton class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded"
                    (click)="toggle()">
                <span class="navbar-toggler-icon"></span>
            </button> -->
            <!-- MOBILE UI -->
            <!-- <div *ngIf="isMenuTogglerDisplayed()" class="collapse navbar-collapse" [ngClass]='{"show": isExpanded}' id="navbarSupportedContent"> -->
                <!--<ul class="row no-gutters" style="list-style: none; padding-left: 0px;">
            <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
              <a class="nav-link d-flex" [routerLink]='[ENavigationRoute.Home]'>
                <div class="lnr lnr-construction d-inline-block"></div>
                <div class="d-inline-block ml-3 align-self-center">Chantiers</div>
              </a>
            </li>
            <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
              <a class="nav-link d-flex" [routerLink]='[ENavigationRoute.Home]'>
                <div class="lnr lnr-calendar-full d-inline-block"></div>
                <div class="d-inline-block ml-3 align-self-center">Mes interventions</div>
              </a>
            </li>
             <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
        <a class="nav-link d-flex" [routerLink]='[ENavigationRoute.Config]'>
          <div class="lnr lnr-cog d-inline-block"></div>
          <div class="d-inline-block ml-3 align-self-center">Configuration</div>
        </a>
      </li> 
            <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
              <a class="nav-link d-flex" [routerLink]=''>
                <div class="lnr lnr-power-switch d-inline-block"></div>
                <div class="d-inline-block ml-3 align-self-center">Déconnexion</div>
              </a>
            </li>
          </ul> -->
            <!-- </div> -->
            <!-- DESKTOP UI -->
            <!-- <div class="collapse navbar-collapse justify-content-end" [ngClass]='{"show": !isMenuTogglerDisplayed()}'>
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item clickable" [routerLinkActive]='["link-active"]'>
                        <a class="nav-link" [routerLink]='[ENavigationRoute.Home]'>
                            <div class="lnr lnr-construction"></div>
                            Mes chantiers
                        </a>
                    </li>
                    <li class="nav-item clickable" [routerLinkActive]='["link-active"]'>
                        <a class="nav-link" [routerLink]='[ENavigationRoute.Home]'>
                            <div class="lnr lnr-calendar-full"></div>
                            Mes interventions
                        </a>
                    </li> -->
                    <!-- <li class="nav-item clickable" [routerLinkActive]='["link-active"]'>
        <a class="nav-link" [routerLink]='[ENavigationRoute.Config]'>
          <div class="lnr lnr-cog"></div>
          Configuration
        </a>
      </li> -->
                    <!-- <li class="nav-item clickable" [routerLinkActive]='["link-active"]' (click)="logout()">
              <a class="nav-link" [routerLink]=''>
                <div class="lnr lnr-power-switch"></div>
                Déconnexion
              </a>
            </li> -->
                <!-- </ul> -->

            <!-- </div> -->
            <!-- <div *ngIf="!IsLoggedIn()" class="collapse navbar-collapse" style="height: 61px;">
           This a dummy container to align the header
        </div> -->
        </div>
    </nav>
    <!-- <mat-progress-bar [style.opacity]="Opacity" mode="indeterminate" color="accent" role="progressbar"
                      style="z-index: 9999;">
    </mat-progress-bar> -->
</header>